import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import type { E164Number } from 'libphonenumber-js';
import 'react-datepicker/dist/react-datepicker.css';
import i18n from '../../i18n';
import { Circles } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux';
import {sendOtpRegister } from '../../features/auth/registerSlice';
import { AppDispatch, RootState } from '../../store';
import { useNavigate } from 'react-router-dom';
import OtpStep from '../auth/OtpStep';
import { editPhoneNumber } from '../../features/auth/userSlice';

const AddNumber = () => {
    const { t } = useTranslation();



    const dispatch = useDispatch<AppDispatch>();
    const { loading } = useSelector((state: RootState) => state.register);
    const { user } = useSelector((state: RootState) => state.user);
    const navigate = useNavigate();
    const [step, setStep] = useState<"form" | "otp">("form");
    const [phone, setPhone] = useState<E164Number | undefined>();
    ;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (phone) {
            const res = await dispatch(sendOtpRegister(phone)).unwrap();
            if (res?.success) {
                setStep("otp");
            }
        }
    };

    const handleVerified = () => {
        if (!phone) return;
        dispatch(editPhoneNumber({ userId: user?.id, phoneNumber: encodeURIComponent(phone) }))
        navigate("/me")
    };

    const handleResend = async () => {
        if (phone) {
            await dispatch(sendOtpRegister(phone)).unwrap();
        }
    };

    if (step === "otp") {
        return <OtpStep phone={String(phone)} onVerified={handleVerified} onResend={handleResend} />
    }

    return (
        <div dir={i18n.language === "ar" ? "rtl" : "ltr"}  >
            <div className=' mb-5'>
                <p className=' text-lg text-textSecond mt-4'>{t("phone-number-required")}</p>
            </div>
            <form className=' relative text-black ' onSubmit={handleSubmit}>
                <div className="flex flex-col gap-2">
                    <label htmlFor="phone" className=' font-medium text-lg '>
                        {t("number")}
                    </label>
                    <PhoneInput
                        id="phone"
                        international
                        defaultCountry="LY"
                        value={phone}
                        onChange={setPhone}
                        className="phone-input border w-full h-full border-grayColor rounded-lg p-3 bg-white focus:outline-none"
                    />
                </div>
                <div className='w-full bg-secondry rounded-lg py-3 mt-5 text-white cursor-pointer flex items-center justify-center'>
                    {loading ? (
                        <Circles
                            height="20"
                            width="20"
                            color="#fff"
                            ariaLabel="circles-loading"
                            visible={true}
                        />
                    ) : (
                        <input type="submit" value={t("next")} className='w-full cursor-pointer' />
                    )}
                </div>
            </form>
        </div>
    )
}

export default AddNumber;
